// src/data/gyms/ElementAllStars.js
export const ElementAllStars = {
  id: "elementallstars",
  name: "Element All Stars",
  color: "#1D4ED8", // Bold Blue
  lightColor: "#EFF6FF",
  logo: "⚡️",

  teams: [
    { id: "vortex", name: "Vortex", level: "L3.2 Senior - PREP" },
    { id: "frost", name: "Frost", level: "L1.1 Youth - PREP" },
    {
      id: "ladiesofelectra",
      name: "Ladies Of Electra",
      level: "L3 Senior - D2",
    },
    { id: "highvoltage", name: "High Voltage", level: "L2 Junior - Flex - D2" },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "8:52 AM",
      teamId: "vortex",
      meet: "8:16 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "9:13 AM",
      teamId: "frost",
      meet: "8:37 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "1:37 PM",
      teamId: "ladiesofelectra",
      meet: "1:01 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "3:54 PM",
      teamId: "highvoltage",
      meet: "3:18 PM",
      panel: "Hall B",
    },

    // ================= SUNDAY (Dec 14) =================
    {
      day: "Sunday",
      time: "10:45 AM",
      teamId: "ladiesofelectra",
      meet: "10:09 AM",
      panel: "Hall A",
    },
    {
      day: "Sunday",
      time: "2:28 PM",
      teamId: "highvoltage",
      meet: "1:52 PM",
      panel: "Hall B",
    },
    // Note: Vortex & Frost are PREP and only compete Saturday.
  ],
};
